module.exports = __webpack_public_path__ + "static/cherryGrove.8bb3d4ba.jpg";